/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S21_HeadingInputs */

const tr_mesafeli_s21_heading = /** @type {(inputs: Mesafeli_S21_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21. Değişiklikler ve Yürürlük`)
};

const en_mesafeli_s21_heading = /** @type {(inputs: Mesafeli_S21_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21. Amendments and Entry into Force`)
};

const de_mesafeli_s21_heading = /** @type {(inputs: Mesafeli_S21_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21. Änderungen und Inkrafttreten`)
};

const ru_mesafeli_s21_heading = /** @type {(inputs: Mesafeli_S21_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21. Изменения и вступление в силу`)
};

/**
* | output |
* | --- |
* | "21. Amendments and Entry into Force" |
*
* @param {Mesafeli_S21_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s21_heading = /** @type {((inputs?: Mesafeli_S21_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S21_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s21_heading(inputs)
	if (locale === "de") return de_mesafeli_s21_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s21_heading(inputs)
	return tr_mesafeli_s21_heading(inputs)
});